import RingLoader from '@/components/Common/RingLoader';

import * as S from '../styles';

export default {
    props: {
        isLoading: {
            type: Boolean,
            default: false,
        },
    },
    render() {
        const { isLoading } = this;

        return (
            <S.MainTitle>
                <S.LeftWrapper>
                    <S.MainTitleTop>
                        {this.$t('NEW_DASHBOARD.edit_widget_settings')}
                    </S.MainTitleTop>
                </S.LeftWrapper>

                {isLoading && (
                    <S.HeaderLoaderWrapper>
                        <RingLoader size={20} />
                        <span>{this.$t(`COMMON.statistics_loading`)}</span>
                    </S.HeaderLoaderWrapper>
                )}
            </S.MainTitle>
        );
    },
};
